<!-- Default Style Menu -->
<div *ngIf="menustyle === 'default'" [style.top]="cellactiontop" [style.left]="cellactionleft"
        [hidden]="!cellactionvisible" class="box-shadow cellinfoback cell-action-menu" (click)="showhidemenu($event)"
        style="position: absolute;z-index:9999;padding:5px 12px;border-radius:5px;background:rgb(255, 255, 255);cursor:pointer">
        <i class="fa-solid fa-lightbulb" style="color:rgb(255, 187, 0)"></i>&nbsp;<i class="fa-solid fa-sort-down"></i>
        <div class="" [hidden]="!cellactionmenuvisible" style="background-color: white;padding:6px 12px;"
                (click)="$event.stopPropagation()">
                <div *ngIf="curSelectedRow<outputrow"
                        style="position:relative;font-weight:bold;top: -28px;    left: 25px;width:100px">
                        Add control
                </div>
                <div *ngIf="curSelectedRow<outputrow"
                        style="position:absolute;z-index:2;background-color:white;padding:2px 2px;left:0px;top:33px;width:100%">
                        <div class="contextmenuitem" [class.active]="contextmenuitem1 == 1" (click)="addGui('label')"><i
                                        class="fa fa-window"></i> label</div>
                        <div class="contextmenuitem" [class.active]="contextmenuitem1 == 2" (click)="addGui('textbox')">
                                <i class="fa fa-door"></i> textbox
                        </div>
                        <div class="contextmenuitem" [class.active]="contextmenuitem1 == 3" (click)="addGui('number')">
                                <i class="fa fa-door"></i> number
                        </div>
                        <div class="contextmenuitem" [class.active]="contextmenuitem1 == 4"
                                (click)="addGui('checkbox')"><i class="fa fa-door"></i> checkbox</div>
                        <div class="contextmenuitem" [class.active]="contextmenuitem1 == 5" (click)="addGui('radio')"><i
                                        class="fa fa-door"></i> radio</div>
                        <div class="contextmenuitem" [class.active]="contextmenuitem1 == 6"
                                (click)="showfilesDialog('png')"><i class="fa fa-door"></i> image...</div>
                        <div class="contextmenuitem" [class.active]="contextmenuitem1 == 7" (click)="addGui('select')">
                                <i class="fa fa-door"></i> select
                        </div>
                        <div class="contextmenuitem" [class.active]="contextmenuitem1 == 8" (click)="addGui('slider')">
                                <i class="fa fa-door"></i> slider
                        </div>
                        <div class="contextmenuitem" [class.active]="contextmenuitem1 == 9"
                                (mouseover)="showOverlaymenu1=true;showSheetsmenu=false;"><i class="fa fa-door"></i>
                                other <i class="fa fas fa-caret-right"></i></div>
                </div>
                <div *ngIf="showOverlaymenu1"
                        style="left: 68px; top: 100px; background: white; position: relative; z-index: 999;">
                        <div class="contextmenuitem" [class.active]="contextmenuitem1 == 22"
                                (click)="addGui('expansion')"><i class="fa fa-door"></i> expansion</div>
                        <div class="contextmenuitem" [class.active]="contextmenuitem1 == 23"
                                (click)="addGui('colorchooser')"><i class="fa fa-door"></i> colorchooser</div>
                        <div class="contextmenuitem" [class.active]="contextmenuitem1 == 24" (click)="addGui('html')"><i
                                        class="fa fa-door"></i> html</div>
                        <div class="contextmenuitem" [class.active]="contextmenuitem1 == 21" (click)="addGui('button')">
                                <i class="fa fa-door"></i> button
                        </div>
                        <div class="contextmenuitem" [class.active]="contextmenuitem1 == 24"
                                (click)="addGui('savebutton')">save
                                button</div>
                        <div class="contextmenuitem" [class.active]="contextmenuitem1 == 25"
                                (click)="addGui('exportbutton')">export
                                button</div>
                        <div class="contextmenuitem" [class.active]="contextmenuitem1 == 26" (click)="addGui('timer')">
                                timer</div>
                </div>
                <div *ngIf="curSelectedRow>outputrow && cellactionmenuvisible"
                        style="position:relative;font-weight:bold;top: -28px;    left: 25px;width:100px">
                        Add object
                </div>
                <div *ngIf="curSelectedRow>outputrow && cellactionmenuvisible"
                        style="position:absolute;z-index:2;background-color:white;padding:2px 2px;left:0px;top:33px;width:100%">
                        <div class="contextmenuitem" [class.active]="contextmenuitem == 1"
                                (click)="addPrimitive('extrusion')"><i class="fa fa-window"></i> extrusion</div>
                        <div class="contextmenuitem" [class.active]="contextmenuitem == 2"
                                (click)="showfilesDialog('gltf')"><i class="fa fa-door"></i> 3D file...</div>
                        <!-- <div class="contextmenuitem" [class.active]="contextmenuitem == 13" (click)="addPrimitive('copy')"><i class="fa fa-copy"></i> copy object...</div> -->
                        <div class="contextmenuitem" [class.active]="contextmenuitem == 3"
                                (click)="addPrimitive('line')"><i class="fa fa-door"></i> line</div>
                        <div class="contextmenuitem" [class.active]="contextmenuitem == 3.5"
                                (click)="addPrimitive('dimensionline')"><i class="fa fa-ru2ler"></i> dimension line
                        </div>
                        <div class="contextmenuitem" [class.active]="contextmenuitem == 4"
                                (click)="addPrimitive('shape')"><i class="fa fa-door"></i> shape</div>
                        <div class="contextmenuitem" [class.active]="contextmenuitem == 5"
                                (click)="addPrimitive('cube')"><i class="fa fa-door"></i> cube</div>
                        <div class="contextmenuitem" [class.active]="contextmenuitem == 6"
                                (click)="addPrimitive('cylinder')"><i class="fa fa-door"></i> cylinder</div>
                        <div class="contextmenuitem" [class.active]="contextmenuitem == 6.5"
                                (click)="addPrimitive('ibeam')">
                                <i class="fa fa-i2ndustry"></i> I-beam
                        </div>
                        <div class="contextmenuitem" [class.active]="contextmenuitem == 7"
                                (click)="showfilesDialog('png',false,true)"><i class="fa fa-door"></i> image...</div>
                        <div class="contextmenuitem" [class.active]="contextmenuitem == 8"
                                (mouseover)="showSheetsmenu=false;showOverlaymenu=false;showothermenu=false;"
                                (click)="addPrimitive('textflat')"><i class="fa fa-door"></i>
                                textflat</div>
                        <div class="contextmenuitem" [class.active]="contextmenuitem == 9"
                                (mouseover)="showothermenu=true;showSheetsmenu=false;"><i class="fa fa-door"></i> other
                                <i class="fa fas fa-caret-right"></i>
                        </div>
                        <div class="contextmenuitem" [class.active]="contextmenuitem == 10"
                                (mouseover)="showSheetsmenu=true;showOverlaymenu=false;showothermenu=false;"><i
                                        class="fa fa-door"></i>
                                sheet <i class="fa fas fa-caret-right"></i></div>
                        <div class="contextmenuitem" [class.active]="contextmenuitem == 11"
                                (mouseover)="showOverlaymenu=true;showSheetsmenu=false;showothermenu=false;"><i
                                        class="fa fa-door"></i>
                                overlay <i class="fa fas fa-caret-right"></i></div>

                        <div class="contextmenuitem" [class.active]="contextmenuitem == 12" *ngIf="sheetid==0"
                                (mouseover)="showSheetsmenu=false;showOverlaymenu=false;"
                                (click)="openInsertObjectDialog()"><i class=" fa fa-door"></i>
                                project...</div>
                </div>
                <div *ngIf="showothermenu"
                        style="left: 68px; top: 130px; background: white; position: relative; z-index: 999;">
                        <div class="contextmenuitem" [class.active]="contextmenuitem == 40"
                                (click)="addPrimitive('subtraction')"><i class="fa fa-door"></i> subtraction </div>
                        <div class="contextmenuitem" [class.active]="contextmenuitem == 40.5"
                                (click)="addPrimitive('union')"><i class="fa fa-door"></i> union </div>
                        <div class="contextmenuitem" [class.active]="contextmenuitem == 41"
                                (click)="addPrimitive('sphere')"><i class="fa fa-door"></i> sphere </div>
                        <div class="contextmenuitem" [class.active]="contextmenuitem == 41.6"
                                (click)="addPrimitive('capsule')"><i class="fa fa-capsules"></i> capsule </div>
                        <div class="contextmenuitem" [class.active]="contextmenuitem == 41.5"
                                (click)="addPrimitive('ring')"><i class="fa fa-circle-o"></i> ring </div>
                        <div class="contextmenuitem" [class.active]="contextmenuitem == 42"
                                (click)="addPrimitive('surface')"><i class="fa fa-door"></i> surface </div>
                        <div class="contextmenuitem" [class.active]="contextmenuitem == 43"
                                (click)="addPrimitive('light')"><i class="fa fa-door"></i> light </div>
                        <div class="contextmenuitem" [class.active]="contextmenuitem == 13"
                                (click)="addPrimitive('profile')"><i class="fa fa-door"></i> profile</div>
                        <div class="contextmenuitem" [class.active]="contextmenuitem == 44"
                                (click)="addPrimitive('connector')"><i class="fa fa-pl2ug"></i> connector </div>
                        <div class="contextmenuitem" [class.active]="contextmenuitem == 45"
                                (click)="addPrimitive('grid')">
                                measuring grid
                        </div>
                        <div class="contextmenuitem" [class.active]="contextmenuitem == 46"
                                (click)="addPrimitive('arrow')">
                                arrow
                        </div>
                        <div class="contextmenuitem" [class.active]="contextmenuitem == 47"
                                (click)="addPrimitive('tube')">
                                tube
                        </div>
                        <div class="contextmenuitem" [class.active]="contextmenuitem == 48"
                                (click)="addPrimitive('spring')">
                                spring
                        </div>
                        <!-- <div class="contextmenuitem" [class.active]="contextmenuitem == 48" (click)="addPrimitive('cable')">
                                cable
                        </div> -->
                </div>
                <div *ngIf="showSheetsmenu"
                        style="left: 68px; top: 161px; background: white; position: relative; z-index: 999;">
                        <ng-container *ngFor="let t of project?.sheets; let i=index">
                                <div *ngIf="i>0" class="contextmenuitem" [class.active]="contextmenuitem == 20+i "
                                        (click)="addPrimitive('sheet: '+t.name)">{{t.name}}...</div>
                        </ng-container>
                </div>
                <div *ngIf="showOverlaymenu"
                        style="left: 68px; top: 210px; background: white; position: relative; z-index: 999;">
                        <div class="contextmenuitem" [class.active]="contextmenuitem == 31"
                                (click)="addPrimitive('text2d')">Text
                        </div>
                        <div class="contextmenuitem" [class.active]="contextmenuitem == 32"
                                (click)="addPrimitive('rectangle2d')">
                                Rectangle</div>
                        <div class="contextmenuitem" [class.active]="contextmenuitem == 33"
                                (click)="addPrimitive('overlayhtml')">
                                HTML</div>
                </div>
        </div>
</div>

<!-- Circular Style Menu -->
<div *ngIf="menustyle === 'circle'" [style.top]="cellactiontop" [style.left]="cellactionleft"
        [hidden]="!cellactionvisible" class="circular-menu-container cell-action-menu"
        style="position: absolute; z-index: 9999;">

        <!-- Center Button -->
        <div class="center-button" (click)="showhidemenu($event)" [class.active]="cellactionmenuvisible" style="
               width: 60px; 
               height: 60px; 
               border-radius: 50%; 
               background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); 
               display: flex; 
               align-items: center; 
               justify-content: center; 
               cursor: pointer; 
               box-shadow: 0 8px 25px rgba(0,0,0,0.3); 
               transition: all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55);
               position: relative;
               z-index: 10;
          ">
                <i class="fa-solid fa-plus"
                        [style.transform]="'rotate(' + (cellactionmenuvisible ? '45deg' : '0deg') + ')'" style="
                  color: white; 
                  font-size: 20px; 
                  transition: transform 0.3s ease;
             "></i>
        </div>

        <!-- Circular Menu Items -->
        <div *ngIf="cellactionmenuvisible" class="circular-items" style="position: absolute; top: 0; left: 0;"
                (click)="$event.stopPropagation()">

                <!-- Controls Menu Items (for curSelectedRow < outputrow) -->
                <ng-container *ngIf="curSelectedRow < outputrow">
                        <!-- Page navigation for controls -->
                        <div *ngIf="controlItems.length > 8" class="circular-item page-indicator" style="
                         position: absolute; 
                         top: -70px; 
                         left: 30px;
                    ">
                                <div class="page-button" (click)="nextControlPage()"
                                        title="Next Page ({{currentControlPage + 1}}/{{totalControlPages}})">
                                        <span class="page-text">{{currentControlPage + 1}}/{{totalControlPages}}</span>
                                </div>
                        </div>

                        <!-- Dynamic control items -->
                        <div *ngFor="let item of getCurrentControlItems(); let i = index" class="circular-item"
                                (click)="item.action()" [style.position]="'absolute'"
                                [style.top]="getCircularPosition(i, 8).top"
                                [style.left]="getCircularPosition(i, 8).left"
                                [style.animation]="'slideIn 0.3s ease-out ' + (0.1 + i * 0.05) + 's both'">
                                <div class="item-button" [title]="item.title">
                                        <i [class]="item.icon"></i>
                                </div>
                                <!-- Hover label -->
                                <div class="hover-label">{{item.title}}</div>
                        </div>
                </ng-container>

                <!-- Objects Menu Items (for curSelectedRow > outputrow) -->
                <ng-container *ngIf="curSelectedRow > outputrow">
                        <!-- Page navigation for objects -->
                        <div *ngIf="getAllObjectItems().length > 8" class="circular-item page-indicator" style="
                         position: absolute; 
                         top: -70px; 
                         left: 30px;
                    ">
                                <div class="page-button" (click)="nextObjectPage()"
                                        title="Next Page ({{currentObjectPage + 1}}/{{totalObjectPages}})">
                                        <span class="page-text">{{currentObjectPage + 1}}/{{totalObjectPages}}</span>
                                </div>
                        </div>

                        <!-- Dynamic object items -->
                        <div *ngFor="let item of getCurrentObjectItems(); let i = index" class="circular-item"
                                (click)="item.action()" [style.position]="'absolute'"
                                [style.top]="getCircularPosition(i, 8).top"
                                [style.left]="getCircularPosition(i, 8).left"
                                [style.animation]="'slideIn 0.3s ease-out ' + (0.1 + i * 0.05) + 's both'">
                                <div class="item-button" [title]="item.title">
                                        <i [class]="item.icon"></i>
                                </div>
                                <!-- Hover label -->
                                <div class="hover-label">{{item.title}}</div>
                        </div>
                </ng-container>
        </div>
</div>

<style>
        .center-button:hover {
                transform: scale(1.1);
                box-shadow: 0 12px 35px rgba(0, 0, 0, 0.4);
        }

        .center-button.active {
                background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
        }

        .item-button {
                width: 45px;
                height: 45px;
                border-radius: 50%;
                background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
                transition: all 0.3s ease;
                color: white;
                font-size: 16px;
        }

        .item-button:hover {
                transform: scale(1.15);
                box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
                background: linear-gradient(135deg, #fa709a 0%, #fee140 100%);
        }

        .page-button {
                width: 35px;
                height: 35px;
                border-radius: 50%;
                background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
                transition: all 0.3s ease;
                color: white;
                font-size: 10px;
                font-weight: bold;
        }

        .page-button:hover {
                transform: scale(1.1);
                box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
        }

        .page-text {
                font-size: 10px;
                line-height: 1;
        }

        .hover-label {
                position: absolute;
                bottom: -35px;
                left: 50%;
                transform: translateX(-50%);
                background: rgba(0, 0, 0, 0.8);
                color: white;
                padding: 4px 8px;
                border-radius: 4px;
                font-size: 12px;
                white-space: nowrap;
                opacity: 0;
                pointer-events: none;
                transition: opacity 0.3s ease;
                z-index: 1000;
        }

        .circular-item:hover .hover-label {
                opacity: 1;
        }

        .hover-label::before {
                content: '';
                position: absolute;
                top: -4px;
                left: 50%;
                transform: translateX(-50%);
                border-left: 4px solid transparent;
                border-right: 4px solid transparent;
                border-bottom: 4px solid rgba(0, 0, 0, 0.8);
        }

        @keyframes slideIn {
                from {
                        opacity: 0;
                        transform: scale(0.3);
                }

                to {
                        opacity: 1;
                        transform: scale(1);
                }
        }
</style>